import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/catalogos/tipos-de-documentos-de-tanslaciones/';

/**
 * GET Tipos Documentos Traslacion
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getTiposDocumentosTraslacion = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Tipo Documento Traslacion
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getTipoDocumentoTraslacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo Documento Traslacion
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postTipoDocumentoTraslacion = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo Documento Traslacion
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchTipoDocumentoTraslacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo Documento Traslacion
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteTipoDocumentoTraslacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
